/* eslint-disable @typescript-eslint/naming-convention */
import {
  DslInfo,
  CellularStatus,
  Overview,
  SystemDetails
} from './DeviceStatus';

export interface Device extends Record<string, unknown> {
  isActive?: boolean;
  category?: string;
  createdAt?: string;
  name: string;
  serialNumber: string;
  type: string;
  updatedAt?: string;
  uuid: string;
  groupUuid?: string;
  groupName?: string;
  status: string;
  connectionStatus: string;
  location?: string;
  details: Details;
  locationLongitude?: string;
  locationLatitude?: string;
  custom: Record<string, string>;
  firmwareAutoUpdate: boolean;
  autoUpdateCertificateUuid?: string;
  deviceControlCertificateUuid?: string;
  eventsTopic?: string;
  connectionPongTimeout?: number;
  connectionPingInterval?: number;
  connectionSessionTimeout?: number;
  connectionStartedAt?: string;
  realmURI?: string;
  url: string;
  connectionLastMessageAt?: string;
  smartUpdateHistory: DeviceUpdateHistory[];
  smartUpdateInfo: SmartUpdateInfo;
  ip?: string;
  hardwareModel: string;
  firmwareName: string;
  firmwareVersion?: string;
}

export interface Details {
  error?: string;
  updatedAt: string;
  status?: {
    lte2?: CellularStatus;
    lte2_2?: CellularStatus;
    lte_serial2?: CellularStatus;
    lte3?: CellularStatus;
    lte3_2?: CellularStatus;
    lte4?: CellularStatus;
    lte4_2?: CellularStatus;
    lte5?: CellularStatus;
    lte5_2?: CellularStatus;
    dsl2?: DslInfo;
    dsl3?: DslInfo;
    dsl4?: DslInfo;
    dsl5?: DslInfo;
    sysdetail: {
      system: SystemDetails;
    };
    overview?: Overview;
    cellular2?: CellularStatus;
    cellular2_2?: CellularStatus;
    cellular3?: CellularStatus;
    cellular3_2?: CellularStatus;
    cellular4?: CellularStatus;
    cellular4_2?: CellularStatus;
    cellular5?: CellularStatus;
    cellular5_2?: CellularStatus;
  };
}

interface DeviceUpdateHistory extends Record<string, unknown> {
  progress: string;
  executedAt: string;
  targetVersion?: string;
  prevVersion?: string;
  updateImage?: string;
  timezone?: string;
}

export interface ConnectionInfo {
  connectionStatus: string;
  url: string;
  deviceId: string;
}

export interface FirmwareVersion {
  version: string;
  deviceId: string;
}

export interface DeviceGroup extends Record<string, unknown> {
  category?: string;
  type?: string;
  uuid: string;
  createdAt?: string;
  updatedAt?: string;
  name: string;
  managedDevicesCount: number;
}

interface SmartUpdateInfo {
  status: SmartUpdateStatus;
  targetVersion: string;
  errorCode?: string;
  plannedTime: string;
  timezone: string;
}

export enum SmartUpdateStatus {
  PENDING = 'PENDING',
  SCHEDULED = 'SCHEDULED',
  LATEST = 'LATEST',
  FAILED = 'FAILED',
  UNKNOWN = 'UNKNOWN'
}
